// extracted by mini-css-extract-plugin
export var divider = "_3w-0";
export var dividerText = "_3w-1";